'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _history = require('./history.js');

Object.defineProperty(exports, 'history', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_history).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


// WEBPACK FOOTER //
// ./~/instantsearch.js/dist-es5-module/src/lib/routers/index.js